
import React, { Component } from 'react';
import {Modal,Form,Input,Row,Col,DatePicker,InputNumber} from 'antd';
import http from '../../../axios/http';
import messager from '../../ui/messager';
import moment from 'moment';
import DictSelect from '../../ui/DictSelect';

const fields = [
{
    "text": "车架号",
    "field": "vin",
    rules: [
        { max: 20, message: '车架号不能超过20个字符！' },
        { required: true, message: '采购开票日期不能为空！' }
    ]
}
,{
    "text": "交易金额",
    "field": "amount",
    number:true,
    rules: [
        { required: true, message: '采购金额不能为空！' }
    ]
}
,{
    "text": "开票日期",
    "field": "invoiceDate",
    date:true,
    rules: [
        { required: true, message: '采购开票日期不能为空！' }
    ]
}
, {
    "text": "合同类型",
    "field": "type",
    "select": true,
    "category": "BAIYI_CONTRACT_TYPE"
}
];


class OutsideVehicleOrderEditForm extends Component {
    state = {}

    onDateChange = (item, val) => {
        this.props.editData.invoiceDate = val;
    };
    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            //日期转换,存在时区问题
            //values.invoiceDate=new Date(values.invoiceDate).toISOString().split('T')[0]
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
            }           
            values.invoiceDate=this.props.editData.invoiceDate
            if(id===undefined||id == null){
                http.post({
                    url: '/outsideVehicleOrder/save',
                    data: values,
                    success: (res) => {
                        this.props.successCallback(this.props.queryData);
                        this.props.onCancel();
                        messager.notify("保存成功！");
                    }
                });
            }else{
                http.post({
                    url: '/outsideVehicleOrder/update',
                    data: values,
                    success: (res) => {
                        this.props.successCallback(this.props.queryData);
                        this.props.onCancel();
                        messager.notify("保存成功！");
                    }
                });
            }
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.date ? (editData[item.field] == null || editData[item.field] ==="" ? null : moment(editData[item.field]))
                                : editData[item.field],
                        })(
                            item.select?<DictSelect category={item.category} />
                                :item.date?<DatePicker onChange={this.onDateChange} placeholder='选择日期' style={{ width: '100%' }} />
                                    :item.number ?<InputNumber precision={2} style={{ width: '100%' }} />
                                        :<Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    create2Col = (fields) => {
        let dom = this.createDom(fields);
        let result = [];
        for (let i = 0; i < dom.length; i++) {
            let item = <Col key={i} span={11} offset={i % 2 === 0 ? 0 : 2}>{dom[i]}</Col>;
            result.push(item);
        }
        return result;
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="会员信息编辑"
                width={800}
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Row>{this.create2Col(fields)}</Row>
                </Form>
            </Modal>
        );
    }
}

const OutsideVehicleOrderEdit = Form.create()(OutsideVehicleOrderEditForm);

export default OutsideVehicleOrderEdit;